import { EmailNodeConverterRules } from 'common/builder/components/chart/FlowChart/adapters/email/nodes/converter.rules'
import { GenericNodeConverterRules } from 'common/builder/components/chart/FlowChart/adapters/generic/nodes/converter.rules'
import { InstagramNodeConverterRules } from 'common/builder/components/chart/FlowChart/adapters/instagram/nodes/converter.rules'
import { MessengerNodeConverterRules } from 'common/builder/components/chart/FlowChart/adapters/messenger/nodes/converter.rules'
import { SmsNodeConverterRules } from 'common/builder/components/chart/FlowChart/adapters/sms/nodes/converter.rules'
import { TelegramNodeConverterRules } from 'common/builder/components/chart/FlowChart/adapters/telegram/nodes/converter.rules'
import { TikTockNodeConverterRules } from 'common/builder/components/chart/FlowChart/adapters/tiktok/nodes/converter.rules'
import { WhatsAppNodeConverterRules } from 'common/builder/components/chart/FlowChart/adapters/whatsapp/nodes/converter.rules'

export const NodeConversionRules = [
  ...MessengerNodeConverterRules,
  ...InstagramNodeConverterRules,
  ...WhatsAppNodeConverterRules,
  ...TelegramNodeConverterRules,
  ...TikTockNodeConverterRules,
  ...SmsNodeConverterRules,
  ...EmailNodeConverterRules,
  ...GenericNodeConverterRules,
]
